module.exports = __webpack_public_path__ + "static/media/headerCommandsMobile.a00ea9b2.svg";